import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';
import { client } from '../client';
import { RegisterMediaPayload } from '../communication/registersConversationMedia';
import { IGMRegisteredMedia } from '../communication/types/IGMRegisteredMedia';

export const registerAvatarMedia = async (
  payload: RegisterMediaPayload,
  userRole?: string,
): Promise<IGMRegisteredMedia> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const { data } = await client.post<IGMRegisteredMedia>(`${prefix}/media/register_upload`, payload);

  return data;
};
